import React from 'react'
import Aux from '../../../hoc/Auxiliary'
import SectionHeading from '../../../components/Heading'

export const ContentEN = props => {
    return <Aux>
        <SectionHeading priority={1} text='Reasons to choose YURA Housing Complex:' />
        <ul>
            <li>Alow-rise building which is in harmony with its surroundings and complies with the concepts and requirements for a property of a high-standard of construction and exclusivity.</li>
            <li>Big apartments with an excellent exposure and floor areas from 74 to 300 square meters.</li>
            <li>An exclusively easy access–to Vasil Levski Boulevard and Knyaz Boris I Boulevard, with an</li>
            <li>access to the city transport system in all directions.</li>
            <li>Proximity to premium educational institutions</li>
            <li>The building neighbours two parks.</li>
            <li>Top location – a prestigious quarter</li>
            <li>The building is conformed to all requirements for energy efficiencyclass A.</li>
            <li>Excellent sound insulation.</li>
            <li>Parking problem solved.</li>
            <li>Installation access to internet and cable TV</li>
            <li>Preparation forair-conditioning</li>
            <li>Preparation for connection to the gas transmission network</li>
            <li>A small number of apartments per entrance–not many neighbours for a good residential comfort.</li>
            <li>The overall vision and the good appearance of the building. The property has been designed in compliance with the latest trends in architecture and contemporary construction requirements.</li>
            <li>Established high standard, control and guarantees of completion.</li>
        </ul>
    </Aux>
}

export default ContentEN



// WEBPACK FOOTER //
// ./src/routes/WhyJura/components/ContentEN.js